import React from "react";
import ReactToPrint from "react-to-print";

import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilePdf} from '@fortawesome/free-solid-svg-icons'

const currencyFormat = (num) => {
  let convert = parseFloat(num) 
      return '$' + convert.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
   }


class ComponentToPrintPdf extends React.Component {

  render() {

    const data = this.props.data

    console.log('data',data)

    const MuestraProductos = (array) => {
        let resultado = ''
        array.map(item => {
          resultado = item.nombre_producto + ', ' + resultado
        })

        if (resultado.length > 50) {
          const textoCortado = resultado.substring(0, 50) + '...';
          return textoCortado
        }else{ return resultado}
        

    }

    return (
        <div className="impresionPdf pagebreak">
            <h2><img src={this.props.logo} className="logoPdf" /> Informe de Pedidos:</h2>
            <MDBTable small responsive>
                <MDBTableBody>
                    <tr>
                        <td><b>Total:</b></td>
                        <td> {currencyFormat(this.props.resultados.total)}</td>
                        <td><b>Fecha Ini</b></td>
                        <td>{this.props.resultados.fechaIn}</td>
                        <td><b>Fecha Fin</b></td>
                        <td>{this.props.resultados.fechaFin}</td>
                        <td><b>Fecha Impr</b></td>
                        <td>{this.props.resultados.fechaHoy}</td>
                        <td><b>Taxes</b></td> 
                        <td> {currencyFormat(this.props.resultados.taxes)}  </td>
                        <td><b>Envios</b></td>
                        <td> {currencyFormat(this.props.resultados.envios)}  </td>

                    </tr>
            </MDBTableBody>
            </MDBTable>


            <MDBTable small responsive>
                <tr className="tabla">
                    <th>ID</th>
                    <th>Fecha</th>
                    <th>estado</th>
                    <th>Total</th>
                    <th>Envios</th>
                    <th>Taxes</th>
                    <th>Cliente</th>
                    <th>Tel</th>
                    <th>Email</th>
                    <th>Direccion</th>
                    <th>Pedidos</th>
                    
                </tr>
                <MDBTableBody>

                {data.map((item, index) => {
                    
                    return(
                        <tr key={index} className="tabla">
                            
                            <td>BLUE-{item.id}</td>
                            <td>{item.fecha}</td>
                            <td>{item.estado}</td>
                            <td> {currencyFormat(item.total)}  </td>
                            <td> {currencyFormat(item.envios)}  </td>
                            <td> {currencyFormat(item.taxes)}  </td>
                            <td>{item.nombre}</td>
                            <td>{item.telefono}</td>
                            <td>{item.email}</td>
                            <td>{item.direccion}</td> 
                            <td>{MuestraProductos(item.pedidoNombres)}</td> 
                        </tr>
                    )
                }) 

                }

</MDBTableBody>
            </MDBTable>
        </div>
    );
  }
}

//<h4>{this.props.config.titulo}</h4>

class InformePedidosPdf extends React.Component {

  render() {
    const pageStyle = `{ size: 2.5in 4in}`;
    return (
      <div>
        <center>
          <ReactToPrint pageStyle={pageStyle} 
            trigger={() => 
        		<buttom
                    className="btn boton_estandar_blanco float-right"							
      				><FontAwesomeIcon icon={faFilePdf} size="lg"/> PDF
      			</buttom>}
            content={() => this.componentRef}
          />
        </center>
        <ComponentToPrintPdf
          ref={el => (this.componentRef = el)}
          datosFactura={this.props.datosFactura} 
          data={this.props.data}
          logo={this.props.logo}
          resultados={this.props.resultados}/>
      </div>
    );
  }
}

export default InformePedidosPdf;